module.exports = __webpack_public_path__ + "static/img/bridges03.14df1a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/bridges03.jpg
// module id = GnY+
// module chunks = 0